module.exports = __webpack_public_path__ + "static/media/gallery7.067c3fdf.jpg";